

import React, { useState } from "react";
import scannerImg from '../img/aaaservices/scnner.jpg'; // 🔄 Replace with your actual image path
import { FaGift } from "react-icons/fa";
import { FaHeart } from 'react-icons/fa';
import jsPDF from "jspdf";
import { borderBottom } from "@mui/system";
const PaymentPage = () => {
  const [selectedFilter, setSelectedFilter] = useState("upi");
  const [selectedOption, setSelectedOption] = useState(null);
  const [showScanner, setShowScanner] = useState(false);
   const [loading, setLoading] = useState(false); 
  const paymentFilters = [
    // { id: "quikpay", name: "QuikPay" },
    { id: "upi", name: "Pay by any UPI App" },
    { id: "card", name: "Debit/Credit Card" },
    { id: "netbanking", name: "Net Banking" },
    { id: "wallet", name: "Mobile Wallets" },
    { id: "voucher", name: "Gift Voucher" },
    // { id: "points", name: "Redeem Points" },
  ];

  const upiOptions = [
    { name: "Google Pay", id: "gpay",  },
    { name: "Amazon Pay UPI", id: "amazon",  },
    { name: "BHIM", id: "bhim",},
    { name: "Paytm", id: "paytm", },
    { name: "PhonePe", id: "phonepe" },
    { name: "Other UPI", id: "other" },
  ];
  
const [voucherCode, setVoucherCode] = useState("");

const handleApplyVoucher = (voucherCode) => {
  if (voucherCode) {
    alert(`Voucher ${voucherCode} applied successfully!`);
    // You can add logic here to validate the voucher or apply discounts
  }
};


  const [showPromo, setShowPromo] = useState(false);
  const [promoCode, setPromoCode] = useState("");

  const handleApply = () => {
    alert(`Promo code "${promoCode}" applied!`);
    setShowPromo(false); // Close after applying
  };
const [liked, setLiked] = useState(false);

const toggleLike = () => {
  setLiked(!liked);
};

const generatePDF = () => {
  const doc = new jsPDF();

  doc.setFontSize(20);
  doc.text("Invoice", 80, 20);

  doc.setFontSize(12);
  doc.text("Invoice Number: INV-1001", 20, 40);
  doc.text(`Date: ${new Date().toLocaleDateString()}`, 20, 50);

  doc.text("Client Name: John Doe", 20, 70);
  doc.text("Email: johndoe@example.com", 20, 80);

  doc.text("Description", 20, 100);
  doc.text("Quantity", 100, 100);
  doc.text("Price", 140, 100);

  doc.text("Online Course", 20, 110);
  doc.text("1", 100, 110);
  doc.text("₹70000", 140, 110);

  doc.setFontSize(14);
  doc.text("Total: ₹70000", 140, 130);

  doc.setFontSize(10);
  doc.text("Thank you for your payment!", 20, 150);

  doc.save("invoice.pdf");
};
    
 const initiatePayment = async () => {
  setLoading(true);

  // Payment and transaction details
 
      // Razorpay Payment Options for paid courses
      var options = {
        key: "rzp_test_oqm83qg9Z710lA",
        key_secret: "eaHmzOnTh2AqXLFRFWavB29c",
        amount: 1 * 100, // Convert price to paise
        currency: "INR",
        payment_capture: true,
        name: "International Institute Of Automate",
        handler: async function (response) {
          alert(
            "Thanks For Your Interest \n Your Payment has been successfully completed"
          );
  generatePDF();
          // Call API to update payment status
         
        },
        notes: {
          address: "International Institute Of Automate",
        },
        theme: {
          color: "#3399cc",
        },
      };
 
      var pay = new window.Razorpay(options);
      pay.open();
    }



  const renderPaymentContent = () => {
    switch (selectedFilter) {
      case "upi":
        return (
          <div>
            <h3>
              <span style={{ color: "rgb(247 148 29)" }}>UPI</span> – Pay by any UPI App
            </h3>
            <div style={styles.upiGrid}>
              {upiOptions.map((upi) => (
                <label key={upi.id} style={styles.upiItem}>
                  <input
                    type="radio"
                    name="upi"
                    onChange={() => setSelectedOption(upi)}
                    checked={selectedOption?.id === upi.id}
                  />
                  <span style={styles.upiLogo}>{upi.logo}</span>
                  {upi.name}
                </label>
              ))}
            </div>
            <div style={{ marginTop: 20 }}>
      <b>Or Scan QR code</b>
      <div style={styles.qrBox} onClick={() => setShowScanner(true)}>
        <div style={styles.qrPlaceholder}>📷</div>
        <p>Scan QR Code</p>
      </div>

      {showScanner && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalContent}>
            <img src={scannerImg} alt="QR Scanner" style={styles.scannerImg} />
            <br />
            <button style={styles.closeBtn} onClick={() => setShowScanner(false)}>Close</button>
          </div>
        </div>
        
      )}
    </div>
      </div>  
        );
 case "card":
  return (
    <div>
      <h3>
        <span style={{ color: "#ff6b00" }}>Card</span> – Debit/Credit Card Payment
      </h3>
      <div style={styles.cardForm}>
        <input type="text" placeholder="Card Number" style={styles.inputField} />
        <div style={styles.row}>
          <input type="text" placeholder="Expiry (MM/YY)" style={{ ...styles.inputField, flex: 1 }} />
          <input type="text" placeholder="CVV" style={{ ...styles.inputField, flex: 1, marginLeft: "10px" }} />
        </div>
        <input type="text" placeholder="Cardholder Name" style={styles.inputField} />
        <button style={styles.payBtn}>Make Payment</button>
      </div>
    </div>
  );


  case "netbanking":
  return (
    <div>
      <h3>
        <span style={{ color: "#ff6b00" }}>Net Banking</span> – Choose Your Bank
      </h3>

      {/* Quick-select banks */}
      <div style={styles.bankGrid}>
        {[
          { name: "SBI", id: "sbi", },
          { name: "Axis Bank", id: "axis",  },
          { name: "HDFC", id: "hdfc",},
        ].map((bank) => (
          <label key={bank.id} style={styles.bankItem}>
            <input
              type="radio"
              name="bank"
              onChange={() => setSelectedOption(bank)}
              checked={selectedOption?.id === bank.id}
            />
            <span style={styles.bankLogo}>{bank.logo}</span>
            {bank.name}
          </label>
        ))}
      </div>

      {/* Full bank list dropdown */}
      <div style={{ marginTop: "20px" }}>
        <label>
          <b>Select Bank:</b>
          <select
            style={styles.select}
            onChange={(e) =>
              setSelectedOption({ id: e.target.value, name: e.target.options[e.target.selectedIndex].text })
            }
            value={selectedOption?.id || ""}
          >
            <option value="">Select Bank</option>
            <option value="sbi">State Bank of India</option>
            <option value="axis">Axis Bank</option>
            <option value="hdfc">HDFC Bank</option>
            <option value="icici">ICICI Bank</option>
            <option value="bob">Bank of Baroda</option>
            <option value="pnb">Punjab National Bank</option>
            <option value="canara">Canara Bank</option>
            <option value="yesbank">Yes Bank</option>
            <option value="kotak">Kotak Mahindra Bank</option>
            <option value="indusind">IndusInd Bank</option>
            <option value="union">Union Bank of India</option>
            <option value="idbi">IDBI Bank</option>
            <option value="uco">UCO Bank</option>
            <option value="federal">Federal Bank</option>
          </select>
        </label>
      </div>

      <button style={styles.payBtn} disabled={!selectedOption} >
        Proceed to Pay
      </button>
    </div>
  );


  case "wallet":
  return (
    <div>
      <h3>
        <span style={{ color: "#ff6b00" }}>Mobile Wallets</span> – Choose Your Wallet
      </h3>

      {/* Wallet Options */}
      <div style={styles.walletGrid}>
        {[
          { name: "Amazon Pay", id: "amazon",  },
          { name: "Paytm", id: "paytm",},
        ].map((wallet) => (
          <label key={wallet.id} style={styles.walletItem}>
            <input
              type="radio"
              name="wallet"
              onChange={() => setSelectedOption(wallet)}
              checked={selectedOption?.id === wallet.id}
            />
            <span style={styles.walletLogo}>{wallet.logo}</span>
            {wallet.name}
          </label>
        ))}
      </div>

      <button style={styles.payBtn} disabled={!selectedOption}>
        Proceed to Pay
      </button>
    </div>
  );



  case "voucher":
  return (
    <div>
      <h3>
        <span style={{ color: "#ff6b00" }}>Gift Voucher</span> – Apply Your Voucher
      </h3>

      {/* Gift Voucher Field */}
      <div style={styles.voucherBox}>
        <label style={styles.voucherLabel}>
          Enter Your Gift Voucher Number:
          <input
            type="text"
            placeholder="Voucher Number"
            style={styles.voucherInput}
            onChange={(e) => setVoucherCode(e.target.value)}
            value={voucherCode || ""}
          />
        </label>
      </div>

      {/* Apply Now Button */}
      <button
        style={styles.applyBtn}
        disabled={!voucherCode}
        onClick={() => handleApplyVoucher(voucherCode)}
      >
        Apply Now
      </button>
    </div>
  );





      default:
        return (
          <p style={{ fontSize: "18px", color: "#555" }}>
            {paymentFilters.find((f) => f.id === selectedFilter)?.name} feature coming soon...
          </p>
        );
    }
  };

  return (
    <div className="cardpage-filter" style={styles.wrapper}>
      {/* Contact */}
      <div style={styles.header}>
       
        <div style={styles.contactRow}>
          <input placeholder="Email Address" style={styles.input} />
          <input placeholder="+91" style={{ ...styles.input, width: "80px" }} />
          <button style={styles.continueBtn}>Continue</button>
          <button
    onClick={toggleLike}
    style={{
      background: 'transparent',
      border: 'none',
      fontSize: '20px',
      color: liked ? 'green' : 'white',
      cursor: 'pointer',
    }}
    aria-label="Add to Wishlist"
  >
    <FaHeart />
  </button>
        </div>
      </div>

      {/* Promo */}
      <div>
      

      {/* Popup Modal */}
      {showPromo && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalBox}>
            <h3>Apply Promocode</h3>
            <input
              type="text"
              value={promoCode}
              onChange={(e) => setPromoCode(e.target.value)}
              placeholder="Enter promo code"
              style={styles.inputss}
            />
            <div style={styles.modalButtons}>
              <button onClick={handleApply} style={styles.applyBtn}>Apply</button>
              <button onClick={() => setShowPromo(false)} style={styles.cancelBtn}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>

      {/* Payment + Summary */}
      <div style={styles.paymentWrapper}>
        {/* Sidebar */}
        <div style={styles.sidebar}>
          <h3 style={styles.sectionHeading}>Payment options</h3>
          {paymentFilters.map((filter) => (
            <div
              key={filter.id}
              onClick={() => {
                setSelectedFilter(filter.id);
                setSelectedOption(null);
              }}
              style={{
                ...styles.filterBtn,
                backgroundColor:
                  selectedFilter === filter.id ? "#0056b3" : "#f5f5f5",
                color: selectedFilter === filter.id ? "white" : "#333",
              }}
            >
              {filter.name}
            </div>
          ))}
        </div>

        {/* Main Payment Content */}
        <div style={styles.paymentContent}>{renderPaymentContent()}</div>

        {/* Summary Box */}
        <div style={styles.summaryBox}>
          <h4>Summary</h4>
          <table style={styles.table}>
            <tbody>
              <tr>
                <td>Method</td>
                <td>{selectedOption ? selectedOption.name : "Not Selected"}</td>
              </tr>
              <tr>
                <td>Amount</td>
                <td>₹999</td>
              </tr>
              <tr>
                <td>Date</td>
                <td>{new Date().toLocaleDateString()}</td>
              </tr>
            </tbody>
          </table>
          <button 
style={styles.bookBtn} onClick={initiatePayment} disabled={loading}>
        {loading ? 'Processing...' : 'Pay Now'}
      </button>

        </div>
      </div>
    </div>
  );
};

// Internal CSS
const styles = {
  
  wrapper: {
    fontFamily: "Arial, sans-serif",
    margin: "0 auto",
    border: "1px solid blue",
    background: "#fff",
    maxWidth: "1483px",
    height:'650px'
    
  },
  header: {
    padding: "20px",
    backgroundColor: "blue",
    color: "orange",
  },
  contactRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: "10px",
    marginTop: "10px",
  },
  input: {
    padding: "10px",
    borderRadius: "4px",
    border: "1px solid blue",
    flex: 1,
    minWidth: "150px",
    maxWidth:'650px'
  },
  continueBtn: {
    backgroundColor: "orange",
    color: "white",
    border: "none",
    padding: "10px 16px",
    borderRadius: "4px",
    cursor: "pointer",
  },
  promo: {
    
    color:'orange',
    cursor: "pointer",
  },
  paymentWrapper: {
    display: "flex",
    flexWrap: "wrap",
  },
  sidebar: {
    flex: "1 1 180px",
    borderRight: "1px solid orange",
    borderBottom: "1px solid orange",
    background: "#f9f9f9",
    padding: "10px",
    minWidth: "180px",
  },
  sectionHeading: {
    fontSize: "16px",
    marginBottom: "10px",
  },
  filterBtn: {
    padding: "10px",
    borderRadius: "5px",
    marginBottom: "8px",
    cursor: "pointer",
    transition: "0.3s",
  },
  paymentContent: {
    flex: "2 1 400px",
    padding: "20px",
    minWidth: "300px",
  },
  upiGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
    gap: "15px",
  },
  upiItem: {
    border: "1px solid #ddd",
    borderRadius: "6px",
    padding: "10px",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    cursor: "pointer",
  },
  upiLogo: {
    fontSize: "22px",
  },
  qrBox: {
    marginTop: "10px",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    border: "1px dashed #999",
    padding: "10px",
    borderRadius: "6px",
    width: "fit-content",
  },
  qrPlaceholder: {
    fontSize: "24px",
  },
  summaryBox: {
    flex: "1 1 250px",
    backgroundColor: "#f0f8ff",
    borderLeft: "1px solid orange",
    borderBottom: "1px solid orange",
    padding: "20px",
    minWidth: "250px",
  },
  table: {
    width: "100%",
    marginBottom: "20px",
    borderCollapse: "collapse",
  },
  bookBtn: {
    width: "100%",
    padding: "12px",
    backgroundColor: "rgb(247 148 29)",
    color: "white",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "bold",
  },

cardForm: {
  marginTop: "20px",
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  maxWidth: "400px",
},
inputField: {
  padding: "10px",
  border: "1px solid #ccc",
  borderRadius: "4px",
  fontSize: "16px",
  width: "100%",
},
row: {
  display: "flex",
  gap: "10px",
},
payBtn: {
  padding: "12px",
  backgroundColor: "rgb(247 148 29)",
  color: "white",
  border: "none",
  borderRadius: "6px",
  cursor: "pointer",
  fontWeight: "bold",
  marginTop: "10px",
},


bankGrid: {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(120px, 1fr))",
  gap: "15px",
  marginTop: "20px",
},
bankItem: {
  border: "1px solid #ccc",
  padding: "10px",
  borderRadius: "6px",
  display: "flex",
  alignItems: "center",
  gap: "10px",
  cursor: "pointer",
},
bankLogo: {
  fontSize: "22px",
},

select: {
  marginTop: "10px",
  padding: "10px",
  borderRadius: "4px",
  width: "100%",
  border: "1px solid #ccc",
  fontSize: "16px",
},

walletGrid: {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(120px, 1fr))",
  gap: "15px",
  marginTop: "20px",
},
walletItem: {
  border: "1px solid #ccc",
  padding: "10px",
  borderRadius: "6px",
  display: "flex",
  alignItems: "center",
  gap: "10px",
  cursor: "pointer",
},
walletLogo: {
  fontSize: "22px",
},

voucherBox: {
  marginTop: "20px",
},
voucherLabel: {
  fontSize: "16px",
  display: "block",
  marginBottom: "10px",
},
voucherInput: {
  padding: "10px",
  borderRadius: "4px",
  border: "1px solid #ccc",
  width: "100%",
  fontSize: "16px",
},
applyBtn: {
  marginTop: "20px",
  padding: "12px",
  backgroundColor: "rgb(247 148 29)",
  color: "white",
  border: "none",
  borderRadius: "6px",
  cursor: "pointer",
  width: "100%",
  fontWeight: "bold",
},
qrBox: {
     
      
      borderRadius: "8px",
      textAlign: "center",
      width: "150px",
      cursor: "pointer",
      background: "#f9f9f9",
    },
    qrPlaceholder: {
      fontSize: "40px",
    },
    modalOverlay: {
      position: "fixed",
      top: 0, left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0,0,0,0.6)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    },
    modalContent: {
      backgroundColor: "#fff",
      padding: "20px",
      borderRadius: "10px",
      textAlign: "center",
      maxWidth: "90%",
    },
    closeBtn: {
      marginTop: "10px",
      padding: "8px 16px",
      backgroundColor: "#007bff",
      color: "#fff",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
    },
    scannerImg: {
      width: "250px",
      maxWidth: "100%",
      borderRadius: "8px",
    },


     promo: {
    
   
    borderRadius: "8px",
    marginTop: "20px",
    textAlign: "left",
    color: "#333",
    fontWeight: "bold",
  },
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },
  modalBox: {
    backgroundColor: "#fff",
    padding: "30px",
    borderRadius: "12px",
    width: "90%",
    maxWidth: "400px",
    boxShadow: "0 0 20px rgba(0,0,0,0.2)",
    textAlign: "center",
  },
  inputss: {
    padding: "10px",
    fontSize: "16px",
    width: "100%",
    marginTop: "10px",
    marginBottom: "20px",
    borderRadius: "6px",
    border: "1px solid #ccc",
  },
  modalButtons: {
    display: "flex",
    justifyContent: "space-between",
  },
  applyBtn: {
    backgroundColor: "#28a745",
    color: "#fff",
    border: "none",
    padding: "10px 16px",
    borderRadius: "6px",
    cursor: "pointer",
  },
  cancelBtn: {
    backgroundColor: "orange",
    color: "#fff",
    border: "none",
    padding: "10px 16px",
    borderRadius: "6px",
    cursor: "pointer",
  },


};

export default PaymentPage;










// import React, { useState, useEffect } from "react";
// import jsPDF from "jspdf";
// import bannerImage from "../img/aaaservices/vr-picture1.0500ab64429db7be0373.jpg";
// import { useNavigate } from 'react-router-dom';

// const EventPaymentPage = () => {
//   const [loading, setLoading] = useState(false);


// const handleFilter = (filterType) => {
//         // Navigate to homepage with a filter query or state
//         navigate('/', { state: { filter: filterType } });
//     };

//  const navigate = useNavigate(); // useNavigate should be called inside the component

//   // Add Razorpay script once when component mounts
//   useEffect(() => {
//     const script = document.createElement("script");
//     script.src = "https://checkout.razorpay.com/v1/checkout.js";
//     script.async = true;
//     document.body.appendChild(script);
//   }, []);

//   const event = {
//     heading: "Automation Workshop",
//     subText: "Learn practical automation techniques in 2 hours!",
//     bannerImg: bannerImage,
//     price:20,
//     date: "20 May 2025",
//     time: "5:00 PM - 7:00 PM",
//     duration: "2 hours",
//     ageLimit: "15+",
//     languages: ["English", "Hindi"],
//     category: ["Robotics", "Technology"],
//     location: "Online",
//     availability: "Available",
//     description:
//       "Join our hands-on automation workshop and dive deep into the fundamentals of robotics, process automation, and industrial tech. Ideal for students, professionals, and tech enthusiasts!",
//   };

//   const generatePDF = () => {
//     const doc = new jsPDF();
//     doc.setFontSize(20);
//     doc.text("Invoice", 80, 20);

//     doc.setFontSize(12);
//     doc.text("Invoice Number: INV-1001", 20, 40);
//     doc.text(`Date: ${new Date().toLocaleDateString()}`, 20, 50);

//     doc.text("Client Name: John Doe", 20, 70);
//     doc.text("Email: johndoe@example.com", 20, 80);

//     doc.text("Description", 20, 100);
//     doc.text("Quantity", 100, 100);
//     doc.text("Price", 140, 100);

//     doc.text("Online Course", 20, 110);
//     doc.text("1", 100, 110);
//     doc.text("₹70000", 140, 110);

//     doc.setFontSize(14);
//     doc.text("Total: ₹70000", 140, 130);

//     doc.setFontSize(10);
//     doc.text("Thank you for your payment!", 20, 150);

//     doc.save("invoice.pdf");
//   };

//   const openRazorpay = () => {
//     setLoading(true);

//     const options = {
//       key: "rzp_test_oqm83qg9Z710lA", // ✅ Replace with your Razorpay test key
//       amount:event.price * 100, // ₹70000 in paise
//       currency: "INR",
//       name: "International Institute Of Automate",
//       description: "Payment for Automation Workshop",
//       handler: function (response) {
//         alert("Payment Successful! ID: " + response.razorpay_payment_id);
//         generatePDF();
//         setLoading(false);
//       },
//       prefill: {
//         name: "John Doe",
//         email: "john@example.com",
//         contact: "9876543210",
//       },
//       notes: {
//         address: "International Institute Of Automate",
//       },
//       theme: {
//         color: "#007bff",
//       },
//     };

//     const rzp = new window.Razorpay(options);
//     rzp.open();
//   };

//   return (

//     <div>
//             <div style={{
//                 position: 'fixed',
//                 top: '83px',
//                 width: '100%',
//                 backgroundColor: 'white',
//                 zIndex: '1000',
//                 padding: '10px 0',
//                 display: 'flex',
//                 justifyContent: 'center',
//                 gap: '10px'
//             }}>
//                 <button
//                     onClick={() => handleFilter('TecTalks')}
//                     style={{ width: '130px', height: '45px', backgroundColor: 'blue', color: 'white', border: 'none', borderRadius: '40px', fontWeight: 'bold' }}
//                 >
//                     TecTalks
//                 </button>
//                 <button
//                     onClick={() => handleFilter('Programs')}
//                     style={{ width: '130px', height: '45px', backgroundColor: 'blue', color: 'white', border: 'none', borderRadius: '40px', fontWeight: 'bold' }}
//                 >
//                     Programs
//                 </button>
//                 {/* <button
//                     onClick={() => handleFilter('jbs')}
//                     style={{ width: '130px', height: '45px', backgroundColor: 'blue', color: 'white', border: 'none', borderRadius: '40px', fontWeight: 'bold' }}
//                 >
//                     Jobs
//                 </button>
//                 <button
//                     onClick={() => handleFilter('WalkingDrive')}
//                     style={{ width: '130px', height: '45px', backgroundColor: 'blue', color: 'white', border: 'none', borderRadius: '40px', fontWeight: 'bold' }}
//                 >
//                     WalkingDrive
//                 </button> */}
//             </div>
//     <div style={styles.wrapper}>
//       {/* Top Row: Banner + Summary */}
//       <div style={styles.flexRow}>
//         <div style={styles.cardBox}>
//           <h2 style={styles.heading}>{event.heading}</h2>
//           <p style={styles.subtext}>{event.subText}</p>



//           <img src={event.bannerImg} alt="Banner" style={styles.bannerImage} />
//         </div>

//         <div style={styles.summaryBox}>
//           <h3>Order Summary</h3>
//           <table style={{ width: "100%", fontSize: "14px", marginTop: "10px" }}>
//             <tbody>
//               <tr>
//                 <td><strong>Amount:</strong></td>
//                 <td>{event.price}</td>
//               </tr>
//               <tr>
//                 <td><strong>Date:</strong></td>
//                 <td>{event.date}</td>
//               </tr>
//               <tr>
//                 <td><strong>Time:</strong></td>
//                 <td>{event.time}</td>
//               </tr>
//             </tbody>
//           </table>
//           <button style={styles.payButton} onClick={openRazorpay} disabled={loading}>
//             {loading ? "Processing..." : "Proceed to Pay"}
//           </button>
//         </div>
//       </div>

//       {/* Bottom Row: Details + Description */}
//       <div style={styles.flexRow}>
//         <div style={{ ...styles.cardBox, backgroundColor: "#0050b3", color: "white" }}>
//           <h3 style={{ color: "orange" }}>About the Event</h3>
//           <p style={{ fontSize: "14px", lineHeight: "1.6" }}>{event.description}</p>
//         </div>

//         <div style={styles.cardBox}>
//           <h3 style={styles.sectionTitle}>Event Details</h3>
//           <div style={styles.detailsGrid}>
//             <div><strong>Duration:</strong> {event.duration}</div>
//             <div><strong>Age Limit:</strong> {event.ageLimit}</div>
//             <div><strong>Languages:</strong> {event.languages.join(", ")}</div>
//             <div><strong>Category:</strong> {event.category.join(", ")}</div>
//             <div><strong>Location:</strong> {event.location}</div>
//             <div><strong>Availability:</strong> {event.availability}</div>
//           </div>
//         </div>
//       </div>
//     </div>
//      </div>
//   );
// };

// const styles = {
//   wrapper: {
//     fontFamily: "Arial, sans-serif",
//     margin: "0 auto",
//     background: "white",
//     padding: "20px",
//     marginTop:'70px',
//     maxwidth:'1200px'
    
//   },
//   flexRow: {
//     display: "flex",
//     flexWrap: "wrap",
//     gap: "20px",
//     justifyContent: "space-between",
//     marginBottom: "30px",
//   },
//   cardBox: {
//     flex: "1 1 39%",
//     backgroundColor: "#fff",
//     borderRadius: "12px",
//     boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
//     padding: "20px",
//     minWidth: "280px",
//   },
//   heading: {
//     fontSize: "22px",
//     marginBottom: "10px",
//   },
//   subtext: {
//     color: "#666",
//     fontSize: "14px",
//     marginBottom: "20px",
//   },
//   bannerImage: {
//     width: "100%",
//     height: "220px",
//     objectFit: "cover",
//     borderRadius: "8px",
//   },
//   detailsGrid: {
//     display: "grid",
//     gap: "10px",
//     fontSize: "14px",
//   },
//   summaryBox: {
//     flex: "1 1 38%",
//     backgroundColor: "#fff",
//     padding: "20px",
//     borderRadius: "12px",
//     boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
//     minWidth: "260px",
//   },
//   payButton: {
//     marginTop: "20px",
//     width: "100%",
//     backgroundColor: "#007bff",
//     color: "#fff",
//     border: "none",
//     padding: "12px",
//     fontSize: "16px",
//     borderRadius: "6px",
//     cursor: "pointer",
//   },
//   sectionTitle: {
//     fontSize: "18px",
//     marginBottom: "10px",
//     fontWeight: "bold",
//   },
// };

// export default EventPaymentPage;


